import Radium from "radium";
import React, { Component } from "react";
import { httpGet, httpPost, httpPut } from "../../Util/http";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Selectpicker from "../../Common/selectpicker";
import { semanticColors } from "../../Globals/styles";
import { setNavHeader } from "../../MainClient/Navbar/actions";

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      password: undefined,
      errors: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(setNavHeader(true, "Bruger"));
    const { id } = this.props.params;
    if (id === "create-new") {
      this.setState({
        create: true,
      });
    } else {
      httpGet(process.env.REACT_APP_webApiEndPoint + `api/user/get?id=${id}`)
        .then((res) => res.json())
        .then((resp) => {
          console.log("john", resp);
          this.setState({ user: resp });
        })
        .then(() =>
          httpGet(
            process.env.REACT_APP_webApiEndPoint + `api/employee/get?id=${id}`
          )
            .then((res) => res.json())
            .then((resp) => {
              console.log("fra", resp);
              this.setState({
                user: {
                  ...this.state.user,
                  initials: resp.initials,
                  wage: resp.wage,
                },
              });
            })
        );
    }
  }

  validate() {
    const { email, username, fullname, initials } = this.state.user;
    console.log("fra her", this.state);
    const errors = {};
    if (!validateEmail(email)) {
      errors["email"] = "Indtast gyldig email";
    }
    if (!username || username.length === 1) {
      errors["username"] = "Indtast gyldig lønnummer";
    }
    if (!fullname || fullname.length === 1) {
      errors["fullname"] = "Indtast brugerens navn";
    }
    if (!initials) {
      errors["initials"] = "Indtast brugerens initialer";
    }
    this.setState({
      errors,
    });
    return Object.keys(errors).length === 0;
  }

  submit() {
    if (!this.validate()) return;

    this.setState({
      message: undefined,
      password: undefined,
    });

    if (this.state.create) {
      console.log("create");
      const { email, username, fullname, role, wage, initials } =
        this.state.user;
      const url = process.env.REACT_APP_webApiEndPoint + `api/user/`;
      httpPost(url, {
        email,
        username,
        fullname,
        role,
        wage,
        initials,
      })
        .then((res) => res.json())
        .then((resp) => {
          this.setState({
            password: resp.password,
          });
        })
        .catch((err) => {
          try {
            const mes = JSON.parse(err.message);
            if (mes.status === 409) {
              alert("Ops! " + mes.statusText);
            } else {
              alert("noget gik galt!");
            }
          } catch (err) {
            alert("noget gik galt!");
          }
        });
    } else {
      console.log("edit");
      const { email, username, fullname, role, wage, initials, disabled } =
        this.state.user;
      const url = process.env.REACT_APP_webApiEndPoint + `api/user/`;
      httpPut(url, {
        email,
        username,
        fullname,
        role,
        wage,
        initials,
        disabled,
      })
        .then((resp) => {
          this.setState({
            message: "Bruger opdateret",
          });
        })
        .catch((err) => {
          try {
            const mes = JSON.parse(err.message);
            if (mes.status === 409) {
              alert("Ops! " + mes.statusText);
            } else if (mes.status === 404) {
              alert("Hov kontakt support! " + mes.statusText);
            } else {
              alert("noget gik galt!");
            }
          } catch (err) {
            alert("noget gik galt!");
          }
        });
    }
  }

  render() {
    return (
      <div style={styles.container} className="flex-gap">
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            this.submit();
          }}
          style={styles.form}
        >
          <div style={styles.inputWrapper}>
            <label>Lønnummer</label>
            <input
              disabled={!this.state.create}
              readOnly={!this.state.create}
              value={this.state.user.username}
              onChange={(evt) =>
                this.setState({
                  user: { ...this.state.user, username: evt.target.value },
                })
              }
            />
            {this.state.errors["username"] ? (
              <span className="text-danger">
                {this.state.errors["username"]}
              </span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Navn</label>
            <input
              value={this.state.user.fullname}
              onChange={(evt) =>
                this.setState({
                  user: { ...this.state.user, fullname: evt.target.value },
                })
              }
            />
            {this.state.errors["fullname"] ? (
              <span className="text-danger">
                {this.state.errors["fullname"]}
              </span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Initialer</label>
            <input
              value={this.state.user.initials}
              onChange={(evt) =>
                this.setState({
                  user: { ...this.state.user, initials: evt.target.value },
                })
              }
            />
            {this.state.errors["initials"] ? (
              <span className="text-danger">
                {this.state.errors["initials"]}
              </span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Email</label>
            <input
              type="email"
              value={this.state.user.email}
              onChange={(evt) =>
                this.setState({
                  user: { ...this.state.user, email: evt.target.value },
                })
              }
            />
            {this.state.errors["email"] ? (
              <span className="text-danger">{this.state.errors["email"]}</span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Rolle</label>
            <Selectpicker
              defaultValue={this.state.user.role || "Formand"}
              key={"key"}
              items={[
                { id: "Funktionær", name: "Funktionær" },
                { id: "Formand", name: "Formand" },
              ]}
              onChange={(e) =>
                this.setState({ user: { ...this.state.user, role: e } })
              }
            ></Selectpicker>
          </div>
          <div style={styles.inputWrapper}>
            <label>Lønsats</label>
            <input
              value={this.state.user.wage}
              onChange={(evt) =>
                this.setState({
                  user: { ...this.state.user, wage: evt.target.value },
                })
              }
            />
          </div>
          {this.state.create ? (
            <div style={styles.buttonsContainer}>
              {this.state.password ? (
                <div>
                  Brugeren er oprettet ! Brugerens adgangskode er:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {this.state.password}
                  </span>
                  <br />
                  <span style={{ fontStyle: "italic" }}>
                    Adgangskoder kan ændres ved at trykke på knappen "Glemt
                    adgangskode?" på login siden.
                  </span>
                </div>
              ) : (
                <div></div>
              )}
              <button type="submit" className="btn btn-primary">
                Opret
              </button>
            </div>
          ) : (
            <div style={styles.buttonsContainer}>
              <div>
                <label style={{ color: semanticColors.danger }}>Blokeret</label>
                <input
                  type="checkbox"
                  style={{ boxShadow: "none", width: 25, height: 14 }}
                  checked={this.state.user.disabled}
                  onChange={(evt) =>
                    this.setState({
                      user: {
                        ...this.state.user,
                        disabled: evt.target.checked,
                      },
                    })
                  }
                />
              </div>
              {this.state.message ? (
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: semanticColors.success,
                    }}
                  >
                    {this.state.message}
                  </span>
                </div>
              ) : (
                <div></div>
              )}
              <button
                style={styles.buttons}
                type="submit"
                className="btn btn-primary"
              >
                Opdater
              </button>
            </div>
          )}
        </form>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: semanticColors.default,
    height: "100%",
    marginTop: 40,
    padding: 40,
  },
  form: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: 12,
    maxWidth: 720,
  },
  inputWrapper: {
    width: "100%",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  buttons: {
    margin: 6,
  },
};
export default connect()(Radium(withRouter(User)));



// WEBPACK FOOTER //
// ./src/App/Users/User/index.jsx